import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MeetingReminderBaseComponent } from './meeting-reminder.base';

@Component({
  selector: 'app-meeting-reminder-overlay',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './meeting-reminder-overlay.component.html',
  styleUrls: ['./meeting-reminder-overlay.component.scss'],
})
export class MeetingReminderOverlayComponent extends MeetingReminderBaseComponent {}
